export const FAQ_ACTIONS = {
  FETCH_DATA: "FETCH_FAQ_DATA",
  IMAGE_LOADED: "IMAGE_LOADED"
};

export const onImageLoad = () => ({
  type: FAQ_ACTIONS.IMAGE_LOADED
});